/** Calendar boundaries for the period selected in the payroll form (PF-445). */
export function defaultPayrollMonthStart(now = new Date()): string {
  const parts = new Intl.DateTimeFormat("en", {
    timeZone: "America/Bogota", year: "numeric", month: "2-digit",
  }).formatToParts(now);
  const part = (name: string) => parts.find(value => value.type === name)!.value;
  return `${part("year")}-${part("month")}-01`;
}

export function defaultPayrollPeriodEnd(start: string, periodDays: 30 | 15): string {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(start)) return "";
  const date = new Date(`${start}T12:00:00Z`);
  if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== start) return "";
  if (periodDays === 15 && date.getUTCDate() <= 15) return `${start.slice(0, 8)}15`;
  date.setUTCMonth(date.getUTCMonth() + 1, 0);
  return date.toISOString().slice(0, 10);
}
